//#region src/transact_campus_card_account_type.ts
var TransactCampusCardAccountType = /* @__PURE__ */ function(TransactCampusCardAccountType) {
	TransactCampusCardAccountType["StoredValue"] = "stored-value";
	TransactCampusCardAccountType["MealPlan"] = "meal-plan";
	TransactCampusCardAccountType["CashEquivalency"] = "cash-equivalency";
	return TransactCampusCardAccountType;
}(TransactCampusCardAccountType || {});
//#endregion
export { TransactCampusCardAccountType };

//# sourceMappingURL=transact_campus_card_account_type.js.map